var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.466,
    height: 19.469,
    viewBox: "0 0 19.466 19.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-cards",
    transform: "translate(-2.125 -2.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M3.329,13.586a.624.624,0,0,0,.693.544l.733-.089L3.98,17.451a.624.624,0,0,0,.47.747l14.265,3.251a.63.63,0,0,0,.14.016.624.624,0,0,0,.607-.485l1.987-8.721a.623.623,0,0,0-.47-.747l-1.96-.446-1-8.267a.635.635,0,0,0-.7-.544L2.8,4.011a.623.623,0,0,0-.542.7c.39,3.227-.226-1.861,1.073,8.879Zm14.643-7.5-14.89,1.8-.2-1.614,14.89-1.8ZM21.02,12.16,19.033,20.88a.185.185,0,0,1-.22.138L4.547,17.768a.184.184,0,0,1-.138-.22L6.4,8.828a.184.184,0,0,1,.22-.138L20.881,11.94A.183.183,0,0,1,21.02,12.16ZM6.713,8.26a.624.624,0,0,0-.747.47L4.86,13.586l-.889.107a.184.184,0,0,1-.2-.16L3.136,8.32l14.89-1.8.537,4.442ZM2.853,4.447,17.376,2.69a.187.187,0,0,1,.208.163l.143,1.178L2.835,5.832,2.692,4.652a.184.184,0,0,1,.16-.2Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M16.395,46.982l-1.168-.266a.774.774,0,1,0-.344,1.508l1.168.266a.773.773,0,1,0,.344-1.508Zm.153.828a.333.333,0,0,1-.4.251L14.981,47.8a.333.333,0,0,1,.148-.65l1.168.266a.334.334,0,0,1,.251.4Z",
    transform: "translate(-8.502 -31.409)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M26.616,49.312a.774.774,0,0,0-.344,1.508l1.168.266a.774.774,0,1,0,.344-1.508Zm1.321,1.094a.333.333,0,0,1-.4.251l-1.168-.266a.333.333,0,0,1,.148-.65l1.168.266A.333.333,0,0,1,27.937,50.406Z",
    transform: "translate(-16.55 -33.244)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M37.661,53.415l1.168.266a.774.774,0,0,0,.344-1.508L38,51.906a.774.774,0,0,0-.344,1.508Zm-.153-.828a.333.333,0,0,1,.4-.251l1.168.266a.333.333,0,0,1-.148.65l-1.168-.266A.333.333,0,0,1,37.508,52.586Z",
    transform: "translate(-24.598 -35.077)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M50.562,54.767,49.394,54.5a.774.774,0,1,0-.344,1.508l1.168.266a.774.774,0,0,0,.344-1.508Zm.153.828a.333.333,0,0,1-.4.251l-1.168-.266a.333.333,0,0,1,.148-.65l1.168.266A.334.334,0,0,1,50.715,55.6Z",
    transform: "translate(-32.646 -36.911)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M16.357,37.2l-.179.784a.4.4,0,0,0,.3.472l4.324.985a.4.4,0,0,0,.089.01.394.394,0,0,0,.383-.307l.179-.785a.394.394,0,0,0-.3-.472L16.829,36.9a.395.395,0,0,0-.472.3Zm.419.143,4.235.965-.158.7-4.235-.965Z",
    transform: "translate(-9.835 -24.48)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M44.943,38.429l3.657.833a.4.4,0,0,0,.485-.305l.649-2.847a.405.405,0,0,0-.305-.485l-3.656-.833a.4.4,0,0,0-.485.3l-.649,2.848A.406.406,0,0,0,44.943,38.429Zm1.232-1.339-.847-.193.13-.569.847.193Zm-.945.236.847.193-.155.681-.847-.193Zm3.686.388-.847-.193.129-.569.848.193Zm-.253,1.11-.847-.193.155-.681.847.193Zm.48-2.108-1.062-.242a.22.22,0,0,0-.263.166l-.431,1.894L46.351,38.3l.633-2.779,2.312.527Zm-3.435-1.488.847.193-.153.671-.847-.193Z",
    transform: "translate(-29.946 -22.989)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/Payments.f6ce0044c453dd2566d10ef1043ecf69.svg";
export { ForwardRef as ReactComponent };